import { AppRecord, AppRecordStatus } from "models/appRecord";
import printJS from "print-js";

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

const RequestAction = () => {
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [searchTextInput, setSearchTextInput] = useState<string>("");

  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");

  // ----------state getShopEmployeeRequestType----------
  const [loadingGetShopEmployeeRequestType, setLoadingGetShopEmployeeRequestType] = useState<boolean>(false);
  const [userShopRequestTypes, setUserShopRequestTypes] = useState<any>();
  const [activities, setActivities] = useState<any>();
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);

  const getShopEmployeeRequestType = async () => {
    setLoadingGetShopEmployeeRequestType(true);
    try {
      const url = `${RouteApi.getShopEmployeeRequestType}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingGetShopEmployeeRequestType(false);
        setUserShopRequestTypes(response.user_shop_request_types);
        setActivities(response.activities);

        setStorage_host_cluster_Id(response.storage_host_cluster);
      } else {
        setLoadingGetShopEmployeeRequestType(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error: any) {
      setLoadingGetShopEmployeeRequestType(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const mergedRequestTypes = userShopRequestTypes?.map((item: any) => {
    const pendingMatch = activities?.find((p: any) => p.request_type === item.request_type);
    return {
      ...item,
      no_of_pending: pendingMatch?.no_of_pending ?? 0,
    };
  });
  const [employeeInitRequest, setEmployeeInitRequest] = useState<any>();
  const [loadingEmployeeInitRequest, setloadingEmployeeInitRequest] = useState<boolean>(false);

  // ----------------getShopEmployeeRequestSearch------------
  const [employeeInitRequestSearch, setEmployeeInitRequestSearch] = useState<any>(null);
  const [loadingEmployeeInitRequestSearch, setloadingEmployeeInitRequestSearch] = useState<boolean>(false);
  const [loadingEmployeeInitRequestSearchDatail, setloadingEmployeeInitRequestSearchDetail] = useState<boolean>(false);
  const [shopEmployeeLoadingRequestSearch, setShopEmployeeLoadingRequestSearch] = useState<any>(null);
  const [employeeRequestSearchLoading, setEmployeeRequestSearchLoading] = useState<any>(null);

  // -----------------getShopEmployeeRequestCommittee--------------
  const [shopEmployeeRequestCommittee, setShopEmployeeRequestCommittee] = useState<any>();
  const [isAddApproverLoading, setIsAddApproverLoading] = useState<boolean>(false);
  const [page, setPage] = useState(1); // or use scroll_tag if API uses that
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  // --------------submitShopEmployeeRequestUpdateStatus------------
  const [submitShopEmployeeRequestUpdateStatusLoading, setSubmitShopEmployeeRequestUpdateStatusLoading] = useState<boolean>(false);

  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  const [formData, setFormData] = useState<any>({
    starting_date: "",
    ending_date: "",
    no_of_day: "",
    leave_period: "",
    leave_type: "",
    starting_time: "",
    ending_time: "",
    reason: "",
  });
  const [formData2, setFormData2] = useState<any>({
    working_date: "",
    missing_period: "",
    missing_type: "",
    missing_remark: "",
  });
  const [formData3, setFormData3] = useState<any>({
    working_date: "",
    remark: "",
  });
  const [formData4, setFormData4] = useState<any>({
    working_date: "",
    to_shift_group_id: "",
    remark: "",

    to_shift_group: "",
  });
  const [loadingSubmitEmployeeInitRequest, setloadingSubmitEmployeeInitRequest] = useState<boolean>(false);

  const getShopEmployeeInitRequest = async (request_type: string) => {
    setloadingEmployeeInitRequest(true);
    try {
      const url = `${RouteApi.getShopEmployeeInitRequest}token=${token}`;
      const data = {
        shop_id: shopId,
        request_type: request_type,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setEmployeeInitRequest(response.employee_request);
        setloadingEmployeeInitRequest(false);
        getShopEmployeeRequestCommittee("", response.employee_request);
      } else {
        setloadingEmployeeInitRequest(false);

        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error: any) {
      setloadingEmployeeInitRequest(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [dobRequest, setDobRequest] = useState<any>(); // "2025-05-05"
  const { btnToggle } = useAppSelector((state) => state.header);

  const getShopEmployeeRequestSearch = async (request_type: string) => {
    setloadingEmployeeInitRequestSearch(true);
    try {
      const url = `${RouteApi.getShopEmployeeRequestSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        request_type: request_type,
        is_deleted: btnToggle ? 1 : 0,
        search_text: searchTextInput,
        working_date: dobRequest || "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_requests"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_requests"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };

        setEmployeeRequestSearchLoading(stateRecord);
        setEmployeeInitRequestSearch(response.employee_requests);
        setloadingEmployeeInitRequestSearch(false);
      } else {
        setloadingEmployeeInitRequestSearch(false);
      }
    } catch (error: any) {
      setloadingEmployeeInitRequestSearch(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchMoreEmployeeRequestSearch = async ({ next }: { next: string }) => {
    if (!next) return;
    setEmployeeRequestSearchLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_requests"]["data"];
        const nextPage = responses["employee_requests"]["next_page_url"];

        const updatedData = [...(employeeInitRequestSearch?.data || []), ...newEmployees];

        setEmployeeInitRequestSearch({
          ...responses["employee_requests"],
          data: updatedData,
        });

        setEmployeeRequestSearchLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  // ---------------submit -------------

  const handleSave = (status: string) => {
    const updatedRequest = {
      ...employeeInitRequest,
      document: {
        ...(employeeInitRequest?.employee_request?.document || {}),
        ...formData,
      },
    };

    setEmployeeInitRequest(updatedRequest);
    submitShopEmployeeRequestForm(updatedRequest, status); // Pass updated version
  };
  const handleSave2 = (status: string) => {
    const updatedRequest = {
      ...employeeInitRequest,
      document: {
        ...(employeeInitRequest?.employee_request?.document || {}),
        ...formData2,
      },
    };

    setEmployeeInitRequest(updatedRequest);
    submitShopEmployeeRequestForm(updatedRequest, status); // Pass updated version
  };
  const handleSave3 = (status: string) => {
    const updatedRequest = {
      ...employeeInitRequest,
      document: {
        ...(employeeInitRequest?.employee_request?.document || {}),
        ...formData3,
      },
    };

    setEmployeeInitRequest(updatedRequest);
    submitShopEmployeeRequestForm(updatedRequest, status); // Pass updated version
  };

  const handleSave4 = (status: string) => {
    const updatedRequest = {
      ...employeeInitRequest,
      document: {
        ...(employeeInitRequest?.employee_request?.document || {}),
        ...formData4,
      },
    };

    setEmployeeInitRequest(updatedRequest);
    submitShopEmployeeRequestForm(updatedRequest, status); // Pass updated version
  };
  const handleAddApprover = (item: any) => {
    const newApprover = {
      accept_employee_id: item.employee_id,
      accept_user_id: employeeInitRequest?.accept_user_id || 0,
      employee_id: employeeInitRequest?.requester.employee_id,
      employee_user_id: employeeInitRequest?.requester.employee_user_id,
      request_id: employeeInitRequest?.id,
      shop_id: shopId,
      user_id: employeeInitRequest?.user_id,
      accept_employee: {
        ...(employeeInitRequest?.employee_request?.accept_employee || {}),
        ...item,
      },
    };

    const updatedRequest = {
      ...employeeInitRequest,
      approvers: [...(employeeInitRequest?.approvers || []), newApprover],
    };

    setEmployeeInitRequest(updatedRequest);
  };
  const [warning2, setWarning2] = useState(false);

  const submitShopEmployeeRequestForm = async (datas: any, status: string) => {
    setloadingSubmitEmployeeInitRequest(true);
    try {
      const url = `${RouteApi.submitShopEmployeeRequestForm}token=${token}`;
      const data = {
        shop_id: shopId,
        request: datas,
        status: status,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        // hanleClickRemoveURl("staff_id");

        setloadingSubmitEmployeeInitRequest(false);
        setOpenPopoverIndex(null);
        setEmployeeInitRequestSearch((prevItemGroups: any) => {
          const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === response.employee_request?.id ? { ...item, ...response.employee_request } : item));
          const exists = updatedData.some((item: any) => item.id === response.employee_requests?.id);
          if (!exists) {
            updatedData.push(response.employee_request);
          }
          return {
            ...prevItemGroups,
            data: updatedData,
          };
        });
      } else {
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning2(true);
        setloadingSubmitEmployeeInitRequest(false);
      }
    } catch (error: any) {
      setloadingSubmitEmployeeInitRequest(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // --------------getShopEmployeeRequestDetail---------

  const getShopEmployeeRequestDetail = async (id: number) => {
    setOpenPopoverIndex(1);
    setloadingEmployeeInitRequestSearchDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeRequestDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingEmployeeInitRequestSearchDetail(false);

        setEmployeeInitRequest(response.employee_request);
      }
    } catch (error: any) {
      setloadingEmployeeInitRequestSearchDetail(false);
      AppLog.show({
        message: `[getShopEmployeeRequestDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const getShopEmployeeRequestCommittee = async (searchValue: any, datas: any) => {
    setIsAddApproverLoading(true);
    try {
      const url = `${RouteApi.getShopEmployeeRequestCommittee}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_request: datas,
        search_text: searchValue,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeRequestCommittee(response.user_shop_employees);
        setIsAddApproverLoading(false);
      }
    } catch (error: any) {
      setIsAddApproverLoading(false);

      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchMoreDataCommittee = async () => {
    setIsFetching(true);
    try {
      const url = `${RouteApi.getShopEmployeeRequestCommittee}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_request: employeeInitRequest,
        search_text: "",
        page: page + 1,
      };
      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setShopEmployeeRequestCommittee({
          ...shopEmployeeRequestCommittee,
          data: [...(shopEmployeeRequestCommittee?.data || []), ...response?.user_shop_employees?.data],
        });
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchMoreData]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setIsFetching(false);
    }
  };

  const handleScrollCommittee = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {}, 500);
    const container = scrollContainerRef.current;
    if (!container || isFetching) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      fetchMoreDataCommittee();
    }
  };

  const submitShopEmployeeRequestUpdateStatus = async (id: number, status: string, remark: any) => {
    setSubmitShopEmployeeRequestUpdateStatusLoading(true);

    try {
      const url = `${RouteApi.submitShopEmployeeRequestUpdateStatus}token=${token}`;
      const data = { shop_id: shopId, id, status, remark };

      const response = await RequestApi(url, { data });

      if (response.status === "success" && response.employee_request?.status !== "Deleted") {
        const updatedRequest = {
          ...employeeInitRequest,
          status: response?.employee_request.status,
        };
        setEmployeeInitRequest(updatedRequest);
        setEmployeeInitRequestSearch((prevItemGroups: any) => {
          const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === response.employee_request?.id ? { ...item, ...response.employee_request } : item));
          const exists = updatedData.some((item: any) => item.id === response.employee_requests?.id);
          if (!exists) {
            updatedData.push(response.employee_request);
          }
          return {
            ...prevItemGroups,
            data: updatedData,
          };
        });
      } else {
        setEmployeeInitRequestSearch((prevItemGroups: any) => {
          return {
            ...prevItemGroups,
            data: (prevItemGroups.data || []).filter((item: any) => item.id !== response.employee_request?.id),
          };
        });
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning2(true);
      }
    } catch (error: any) {
      AppLog.show({
        message: `[submitShopEmployeeRequestUpdateStatus]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setSubmitShopEmployeeRequestUpdateStatusLoading(false);
    }
  };
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);

  const handlePrint = async (request_type: string) => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-request-report?token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        storage_host_cluster_id: storage_host_cluster_Id.id,
        working_date: dobRequest,
        request_type: request_type,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return {
    loadingPrint,
    btnToggle,
    handlePrint,
    dobRequest,
    setDobRequest,
    // ---------state getShopEmployeeRequestType-------
    setOpenPopoverIndex,
    openPopoverIndex,
    getShopEmployeeRequestType,
    loadingGetShopEmployeeRequestType,
    setLoadingGetShopEmployeeRequestType,
    userShopRequestTypes,
    setUserShopRequestTypes,
    storage_host_cluster_Id,
    setStorage_host_cluster_Id,
    // ------------init request--------
    getShopEmployeeInitRequest,
    employeeInitRequest,
    loadingEmployeeInitRequest,
    setEmployeeInitRequest,
    // ---------submit------
    submitShopEmployeeRequestForm,
    loadingSubmitEmployeeInitRequest,
    formData,
    setFormData,
    formData2,
    setFormData2,
    formData3,
    setFormData4,
    formData4,
    setFormData3,
    handleSave,
    handleSave2,
    handleSave3,
    handleSave4,

    // ----------get init search -------

    getShopEmployeeRequestSearch,
    employeeInitRequestSearch,
    loadingEmployeeInitRequestSearch,
    searchTextInput,
    setSearchTextInput,
    shopEmployeeLoadingRequestSearch,
    fetchMoreEmployeeRequestSearch,
    employeeRequestSearchLoading,

    // ---------get datail----------
    getShopEmployeeRequestDetail,
    loadingEmployeeInitRequestSearchDatail,
    // ------ShopEmployeeRequestCommittee----------

    getShopEmployeeRequestCommittee,
    shopEmployeeRequestCommittee,
    setShopEmployeeRequestCommittee,
    handleAddApprover,
    isAddApproverLoading,
    // scroll Committee
    handleScrollCommittee,
    scrollContainerRef,
    warning,
    warning2,
    setWarning2,
    errorStatus,
    fetchMoreDataCommittee,
    activities,
    // -------------submitShopEmployeeRequestUpdateStatus-------
    submitShopEmployeeRequestUpdateStatus,
    submitShopEmployeeRequestUpdateStatusLoading,
    mergedRequestTypes,
  };
};

export default RequestAction;
